var _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemsShipped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "599.044px",
    height: "582.159px",
    viewBox: "6.12 31.254 599.044 582.159",
    enableBackground: "new 6.12 31.254 599.044 582.159",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B289E9",
    points: "300.822,151.977 236.348,113.807 378.516,31.254 439.973,66.946 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B289E9",
    points: "446.301,70.618 520.678,113.807 378.516,197.969 307.09,155.686 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B289E9",
    points: "143.777,613.413 6.12,529.789 6.12,353.533 143.777,435.872 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B289E9",
    points: "154.071,613.413 290.443,529.789 290.443,353.533 154.071,435.872 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B289E9",
    points: "225.975,382.481 290.443,344.311 148.281,261.764 86.824,297.45 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B289E9",
    points: "80.497,301.122 6.12,344.311 148.281,428.473 219.708,386.189 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B289E9",
    d: "M387.476,209.86c23.696-13.832,49.578-20.747,77.645-20.747c19.584,0,38.091,3.452,55.551,10.19V123.03 l-137.657,82.338v7.283C384.501,211.721,385.951,210.748,387.476,209.86z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B289E9",
    d: "M387.476,477.745c-1.524-0.894-2.975-1.86-4.462-2.791v62.987l76.402-39.627 C433.553,497.427,409.551,490.621,387.476,477.745z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B289E9",
    d: "M331.178,421.447c-13.838-23.703-20.747-49.579-20.747-77.645c0-28.066,6.91-53.948,20.747-77.651 c10.814-18.531,24.694-34.002,41.543-46.5v-14.284L236.348,123.03v179.273l62.406,37.026l0.049,159.91l73.918,38.703v-69.988 C355.872,455.456,341.992,439.979,331.178,421.447z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B289E9",
    d: "M586.382,273.502c12.521,21.457,18.782,44.89,18.782,70.301c0,25.41-6.261,48.837-18.782,70.294 c-12.527,21.457-29.511,38.446-50.968,50.968c-21.456,12.509-44.89,18.77-70.294,18.77c-25.41,0-48.838-6.261-70.294-18.776 c-21.457-12.521-38.446-29.51-50.968-50.967c-12.527-21.457-18.782-44.884-18.782-70.294s6.255-48.837,18.782-70.3 c12.521-21.451,29.511-38.44,50.968-50.961c21.45-12.521,44.884-18.782,70.294-18.782c25.404,0,48.838,6.261,70.294,18.782 C556.871,235.063,573.854,252.052,586.382,273.502z M559.209,314.255c0-3.397-1.09-6.194-3.28-8.385l-16.592-16.414 c-2.313-2.307-5.049-3.464-8.213-3.464s-5.894,1.157-8.207,3.464l-74.389,74.217l-41.212-41.206 c-2.307-2.313-5.043-3.464-8.207-3.464s-5.899,1.15-8.207,3.464l-16.591,16.408c-2.191,2.191-3.28,4.988-3.28,8.391 c0,3.28,1.089,6.016,3.28,8.207l66.01,66.004c2.308,2.313,5.043,3.47,8.207,3.47c3.28,0,6.077-1.156,8.391-3.47l99.016-99.009 C558.119,320.277,559.209,317.542,559.209,314.255z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsShipped);
export default __webpack_public_path__ + "static/media/itemsShipped.6a3910de9203336dacae905f5410425f.svg";
export { ForwardRef as ReactComponent };